import { motion } from "framer-motion";
import { ArrowRight, Clock, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE, waLink } from "@/data/site";

const WhatsAppIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

export const WhatsAppConcierge = () => (
  <section id="iletisim" data-testid="whatsapp-concierge-section" className="py-16 md:py-24 bg-ivory">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div
          data-testid="whatsapp-concierge-card"
          className="relative overflow-hidden bg-emerald text-ivory px-6 py-12 sm:px-12 md:px-16 md:py-16"
        >
          <div className="grain-overlay" />
          <div className="absolute -top-10 -right-10 pointer-events-none select-none">
            <p className="font-serif text-[10rem] leading-none font-semibold text-outline-ivory">Wa</p>
          </div>
          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-8">
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-ivory/50">Kişisel Danışmanınız</p>
              <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1]">
                Kararsız mı kaldınız?<br />
                <span className="italic text-gold">WhatsApp'tan yazın, birlikte seçelim.</span>
              </h2>
              <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3 text-sm text-ivory/60">
                <span className="inline-flex items-center gap-2">
                  <Clock size={14} className="text-ivory/60" /> Hafta içi 09.00 – 20.00
                </span>
                <span className="inline-flex items-center gap-2">
                  <MapPin size={14} className="text-ivory/60" /> {SITE.address}
                </span>
              </div>
            </div>
            <div className="md:col-span-4 md:justify-self-end">
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="concierge-whatsapp-button"
                className="group inline-flex items-center gap-3 rounded-full bg-ivory px-8 h-[54px] text-sm font-semibold text-emerald transition-colors duration-300 hover:bg-sand"
              >
                <WhatsAppIcon size={18} />
                Sohbeti Başlat
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export const FloatingWhatsApp = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    data-testid="floating-whatsapp-button"
    aria-label="WhatsApp ile iletişime geç"
    className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-emerald text-ivory border border-ivory/25 shadow-2xl shadow-emerald/40 backdrop-blur-xl flex items-center justify-center transition-transform duration-300 hover:scale-110"
  >
    <WhatsAppIcon size={24} />
  </motion.a>
);
